// © Microsoft Corporation. All rights reserved.

import { ActionMap } from "@msnews/experiences-redux";
import { SocialDataState } from "@msnews/social-data-connector";

/**
 * SetTime action signature
 */
export type SetComponent = (id?: string, market?: string) => void;
export type SetSocialData = (socialData: SocialDataState) => void;

/**
 * Class containing actions that apply to the SocialBar connector
 */
export const SocialBarActions = {
    setComponent: new ActionMap<SetComponent>("SetComponent"),
    setSocialData: new ActionMap<SetSocialData>("SetSocialData")
};